import React from "react";
import {useHistory, useLocation} from "react-router-dom";
import { useSelector } from "react-redux";
import { t } from "../common/LocalizationProvider";

import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    makeStyles,
    Tooltip,
} from "@material-ui/core";

import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import DashboardIcon from "@material-ui/icons/Dashboard";
import DescriptionIcon from "@material-ui/icons/Description";
import SettingsIcon from "@material-ui/icons/Settings";
import { cyberStyles } from '../cssShared/cyberTheme';

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
    root: {
        width: '100%',
        backgroundColor: 'transparent',
        marginTop: 'auto',
        paddingBottom: 0,
        marginBottom: 0,
    },

    listItemCollapsed: {
        justifyContent: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        margin: theme.spacing(1, 0),
        '&:hover': {
            backgroundColor: 'rgba(0, 242, 255, 0.1)',
        }
    },
    iconMobile: {
        minWidth: 'auto',
        marginBottom: 4,
        color: 'inherit',
    },
    textDesktop: {
        fontSize: '0.7rem',
        textAlign: 'center',
        marginTop: theme.spacing(0.5),
        color: 'inherit',
    },
    textMobile: {
        fontSize: '0.65rem',
        textAlign: 'center',
        color: 'inherit',
    }
}));

const ButtonsHistory = ({ setDevicesList, hideDrawer }) => {
    const classes = useStyles();
    const history = useHistory();
    const user = useSelector(state => state.session.user);
    const userId = user?.id;
    const location = useLocation()

    const handleSetDevicesList = () => {
        if (setDevicesList) setDevicesList(true);
        else history.push('/');
    }

    const navItems = [
        { icon: <DirectionsCarIcon />, label: t('deviceTitle') ,aliases: ['/'], path: '/', action: handleSetDevicesList },
        { icon: <DashboardIcon />, label: t('dashboardTitle'), aliases: ['/dashboard', '/admin/statistics'], action: () => history.push('/dashboard') },
        { icon: <DescriptionIcon />, label: t('reportTitle'), aliases: ['/reports'],action: () => history.push('/reports/route') },
        { icon: <SettingsIcon />, label: t('settingsTitle'), aliases: ['/user', '/geofences', '/settings', '/admin/users'], action: () => history.push(`/user/${userId}`) },
    ];

    const isSelected = (item) => {
        if (item?.path === '/') {
            return location.pathname === '/';
        }
        return item.aliases?.some(alias => location.pathname.startsWith(alias));
    }

    if (hideDrawer) {
        return (
            <List className={classes.root}>
                {navItems.map((item, index) => {
                    const ItemContent = (
                        <ListItem
                            button
                            key={index}
                            onClick={item.action}
                            selected={isSelected(item)}
                            classes={{
                                root: classes.listItemCollapsed,
                                selected: classes.selected
                            }}
                        >
                            <ListItemIcon className={classes.icon}>
                                {item.icon}
                            </ListItemIcon>
                            {!hideDrawer && (
                                <ListItemText
                                    primary={item.label}
                                    primaryTypographyProps={{ variant: 'body2' }}
                                />
                            )}
                        </ListItem>
                    );

                    return (
                        <Tooltip title={item.label} placement="right" arrow key={index}>
                            {ItemContent}
                        </Tooltip>
                    );
                })}
            </List>
        );
    }
    else {
        return (
            <List className={classes.mobileContainer}>
                <div className={classes.desktopContainer}>
                    {navItems.map((item, index) => (
                        <ListItem
                            button
                            key={index}
                            onClick={item.action}
                            selected={isSelected(item)}
                            classes={{
                                root: classes.listItemDesktop,
                                selected: classes.selected
                            }}
                        >
                            <ListItemIcon className={classes.icon}>
                                {item.icon}
                            </ListItemIcon>
                            <span className={classes.textDesktop}>{item.label}</span>
                        </ListItem>
                    ))}
                </div>
            </List>
        );
    }
}

export default ButtonsHistory;